(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !window.DesignMode) return;
  try {
    
// Carousel navigation
const carousel = document.querySelector('.best-sellers-carousel .carousel-track');
const leftArrow = document.querySelector('.carousel-arrow.left');
const rightArrow = document.querySelector('.carousel-arrow.right');

if (carousel && leftArrow && rightArrow) {
  let autoScroll;
  let currentIndex = 0;
  let isPaused = false;
  let pauseTimeout;
  let arrowTimeout;
  const totalItems = carousel.querySelectorAll('.carousel-item').length;
  const PAUSE_DURATION = 5000; // 5 seconds pause
  const LAST_ITEM_WAIT = 3000; // 3 seconds wait at last item

  // Show/hide arrows with timeout
  function showArrows() {
    leftArrow.style.display = 'flex';
    rightArrow.style.display = 'flex';
    if (arrowTimeout) clearTimeout(arrowTimeout);
    arrowTimeout = setTimeout(() => {
      leftArrow.style.display = 'none';
      rightArrow.style.display = 'none';
    }, 2500);
  }

  // Update arrow states based on current index
  function updateArrowState() {
    leftArrow.disabled = currentIndex === 0;
    rightArrow.disabled = currentIndex === totalItems - 1;
  }

  // Calculate single product scroll width
  function getSingleProductScrollWidth() {
    const item = carousel.querySelector('.carousel-item');
    if (item) {
      const style = window.getComputedStyle(item);
      const margin = parseFloat(style.marginRight) + parseFloat(style.marginLeft);
      return item.offsetWidth + margin;
    }
    return 0;
  }

  // Scroll to specific index with snap behavior
  function scrollToIndex(index) {
    const scrollAmount = getSingleProductScrollWidth() * index;
    carousel.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });
    currentIndex = index;
    updateArrowState();
  }

  // Start auto scroll
  function startAutoScroll() {
    if (autoScroll) clearInterval(autoScroll);
    
    autoScroll = setInterval(() => {
      if (isPaused) return;

      if (currentIndex >= totalItems - 1) {
        // At last item, wait for 3 seconds
        clearInterval(autoScroll);
        setTimeout(() => {
          if (!isPaused) {
            currentIndex = 0;
            scrollToIndex(currentIndex);
            startAutoScroll();
          }
        }, LAST_ITEM_WAIT);
      } else {
        currentIndex++;
        scrollToIndex(currentIndex);
      }
    }, 3500);
  }

  // Pause auto scroll
  function pauseAutoScroll() {
    isPaused = true;
    if (pauseTimeout) clearTimeout(pauseTimeout);
    
    pauseTimeout = setTimeout(() => {
      isPaused = false;
      startAutoScroll();
    }, PAUSE_DURATION);
  }

  // Handle manual navigation
  leftArrow.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      scrollToIndex(currentIndex);
      pauseAutoScroll();
      showArrows();
    }
  });

  rightArrow.addEventListener('click', () => {
    if (currentIndex < totalItems - 1) {
      currentIndex++;
      scrollToIndex(currentIndex);
      pauseAutoScroll();
      showArrows();
    }
  });

  // Handle touch/click interactions
  const productCards = carousel.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.addEventListener('click', () => {
      pauseAutoScroll();
      showArrows();
    });
    
    card.addEventListener('touchstart', () => {
      pauseAutoScroll();
      showArrows();
    });
  });

  // Handle manual scroll
  let scrollTimeout;
  carousel.addEventListener('scroll', () => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    
    // Calculate current index based on scroll position
    const scrollPosition = carousel.scrollLeft;
    const itemWidth = getSingleProductScrollWidth();
    const newIndex = Math.round(scrollPosition / itemWidth);
    
    if (newIndex !== currentIndex) {
      currentIndex = newIndex;
      updateArrowState();
      pauseAutoScroll();
      showArrows();
    }
  });

  // Initialize scroll snap behavior
  carousel.style.scrollSnapType = 'x mandatory';
  const items = carousel.querySelectorAll('.carousel-item');
  items.forEach(item => {
    item.style.scrollSnapAlign = 'center';
  });

  // Hide arrows initially
  leftArrow.style.display = 'none';
  rightArrow.style.display = 'none';

  // Show arrows on first load
  showArrows();

  // Start auto scroll initially
  startAutoScroll();
}

// Initialize AOS if available
if (window.AOS) { 
  AOS.init({ 
    duration: 500, 
    once: true, 
    easing: 'ease-out-cubic' 
  }); 
}

document.addEventListener('shopify:section:load', function() {
  if (window.AOS) { AOS.refresh(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories"] && !window.DesignMode) return;
  try {
    
// AOS init/refresh
if (window.AOS) { AOS.init({ duration: 500, once: true, easing: 'ease-out-cubic' }); }
document.addEventListener('shopify:section:load', function() {
  if (window.AOS) { AOS.refresh(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page"] && !window.DesignMode) return;
  try {
    
// No JavaScript needed - keeping it lightweight

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["men-women-featured"] && !window.DesignMode) return;
  try {
    
// Tab switching
const tabBtns = document.querySelectorAll('.mw-tab-btn');
const tabContents = document.querySelectorAll('.mw-products');
const menVideo = document.getElementById('mw-men-video');
const womenVideo = document.getElementById('mw-women-video');
if (tabBtns.length && tabContents.length) {
  tabBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      tabBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const tab = this.getAttribute('data-tab');
      tabContents.forEach(c => {
        c.style.display = c.getAttribute('data-tab-content') === tab ? '' : 'none';
      });
      if (menVideo && womenVideo) {
        if (tab === 'men') {
          menVideo.style.display = 'block';
          womenVideo.style.display = 'none';
        } else {
          menVideo.style.display = 'none';
          womenVideo.style.display = 'block';
        }
      }
      setTimeout(initMwCarousel, 100); // re-init carousel on tab switch
      setTimeout(() => { if (window.AOS) { AOS.refresh(); } }, 200);
    });
  });
}

// Improved carousel logic per user requirements
let mwCarouselInterval = null;
let mwCarouselPauseTimeout = null;
let mwCarouselListeners = [];
let mwCarouselObserver = null;
function clearMwCarousel() {
  if (mwCarouselInterval) clearInterval(mwCarouselInterval);
  mwCarouselInterval = null;
  if (mwCarouselPauseTimeout) clearTimeout(mwCarouselPauseTimeout);
  mwCarouselPauseTimeout = null;
  mwCarouselListeners.forEach(({grid, handlers}) => {
    handlers.forEach(({event, fn}) => grid.removeEventListener(event, fn));
  });
  mwCarouselListeners = [];
  if (mwCarouselObserver) mwCarouselObserver.disconnect();
  mwCarouselObserver = null;
}
function initMwCarousel() {
  clearMwCarousel();
  document.querySelectorAll('.mw-products-truegrid').forEach(function(grid) {
    if (window.innerWidth > 1000 || grid.scrollWidth <= grid.clientWidth) return;
    const cards = Array.from(grid.querySelectorAll('.mw-product-card'));
    if (cards.length < 2) return;
    let currentIndex = 0;
    let paused = false;
    let pauseAfterInteraction = false;
    let lastScrollLeft = 0;
    // --- Nav Arrows ---
    function getArrow(card, dir) {
      return card.querySelector('.mw-carousel-arrow.' + dir);
    }
    let arrowTimeout = null;
    function showArrows(card) {
      const leftArrow = getArrow(card, 'left');
      const rightArrow = getArrow(card, 'right');
      if (leftArrow) leftArrow.style.display = '';
      if (rightArrow) rightArrow.style.display = '';
      if (arrowTimeout) clearTimeout(arrowTimeout);
      arrowTimeout = setTimeout(() => {
        if (leftArrow) leftArrow.style.display = 'none';
        if (rightArrow) rightArrow.style.display = 'none';
      }, 2500);
    }
    function updateArrowState(card, idx) {
      const leftArrow = getArrow(card, 'left');
      const rightArrow = getArrow(card, 'right');
      if (!leftArrow || !rightArrow) return;
      leftArrow.disabled = idx === 0;
      rightArrow.disabled = idx === cards.length - 1;
    }
    // --- Accurate scrollToIndex ---
    function scrollToIndex(idx, smooth = true) {
      if (idx < 0) idx = 0;
      if (idx >= cards.length) idx = cards.length - 1;
      const card = cards[idx];
      if (!card) return;
      // Use bounding rect for accuracy
      const gridRect = grid.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const left = cardRect.left - gridRect.left + grid.scrollLeft;
      grid.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      currentIndex = idx;
      updateArrowState(card, idx);
    }
    // Intersection Observer to track current product
    mwCarouselObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          const idx = cards.indexOf(entry.target);
          if (idx !== -1) {
            currentIndex = idx;
            updateArrowState(entry.target, idx);
          }
        }
      });
    }, { root: grid, threshold: 0.5 });
    cards.forEach(card => mwCarouselObserver.observe(card));
    // Auto-scroll logic
    function startAutoScroll() {
      if (mwCarouselInterval) clearInterval(mwCarouselInterval);
      mwCarouselInterval = setInterval(() => {
        if (paused) return;
        if (currentIndex < cards.length - 1) {
          scrollToIndex(currentIndex + 1);
        } else {
          scrollToIndex(0);
        }
      }, 3000);
    }
    // Pause/resume logic
    function pauseAutoScroll() {
      paused = true;
      if (mwCarouselInterval) clearInterval(mwCarouselInterval);
      if (mwCarouselPauseTimeout) clearTimeout(mwCarouselPauseTimeout);
      if (pauseAfterInteraction) return;
      pauseAfterInteraction = true;
      mwCarouselPauseTimeout = setTimeout(() => {
        paused = false;
        pauseAfterInteraction = false;
        // Resume auto-scroll from current product
        if (currentIndex < cards.length - 1) {
          scrollToIndex(currentIndex + 1);
        } else {
          scrollToIndex(0);
        }
        startAutoScroll();
      }, 5000);
    }
    // User interaction listeners (only within carousel)
    const handlers = [
      { event: 'touchstart', fn: (e) => { 
        if (e.target.closest('.mw-product-card')) {
          pauseAutoScroll(); 
          showArrows(e.target.closest('.mw-product-card')); 
        }
      }},
      { event: 'mousedown', fn: (e) => { 
        if (e.target.closest('.mw-product-card')) {
          pauseAutoScroll(); 
          showArrows(e.target.closest('.mw-product-card')); 
        }
      }},
      { event: 'wheel', fn: (e) => { 
        if (e.target.closest('.mw-product-card')) {
          pauseAutoScroll(); 
          showArrows(e.target.closest('.mw-product-card')); 
        }
      }},
      { event: 'scroll', fn: () => { 
        if (grid.scrollLeft !== lastScrollLeft) { 
          lastScrollLeft = grid.scrollLeft; 
          // Don't pause on scroll, only update arrows
          showArrows(cards[currentIndex]); 
        } 
      }}
    ];
    handlers.forEach(({event, fn}) => grid.addEventListener(event, fn));
    mwCarouselListeners.push({grid, handlers});
    // Arrow click listeners for each card
    cards.forEach((card, idx) => {
      const leftArrow = getArrow(card, 'left');
      const rightArrow = getArrow(card, 'right');
      if (leftArrow) {
        leftArrow.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex > 0) {
            scrollToIndex(currentIndex - 1);
            showArrows(card);
          }
        });
      }
      if (rightArrow) {
        rightArrow.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex < cards.length - 1) {
            scrollToIndex(currentIndex + 1);
            showArrows(card);
          }
        });
      }
    });
    // Start at first product
    scrollToIndex(0, false);
    startAutoScroll();
    // Show arrows on first load
    showArrows(cards[0]);
  });
}
initMwCarousel();
window.addEventListener('resize', initMwCarousel);
document.addEventListener('shopify:section:load', function() {
  initMwCarousel();
  if (window.AOS) { AOS.refresh(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
// Carousel navigation
const carousel = document.querySelector('.product-slider-carousel .product-carousel-track');
const leftArrow = document.querySelector('.product-carousel-arrow.left');
const rightArrow = document.querySelector('.product-carousel-arrow.right');

if (carousel && leftArrow && rightArrow) {
  let autoScroll;
  let currentIndex = 0;
  let isPaused = false;
  let pauseTimeout;
  const totalItems = carousel.querySelectorAll('.product-carousel-item').length;
  const PAUSE_DURATION = 5000; // 5 seconds pause
  const LAST_ITEM_WAIT = 3000; // 3 seconds wait at last item

  // Calculate single product scroll width
  function getSingleProductScrollWidth() {
    const item = carousel.querySelector('.product-carousel-item');
    if (item) {
      const style = window.getComputedStyle(item);
      const margin = parseFloat(style.marginRight) + parseFloat(style.marginLeft);
      return item.offsetWidth + margin;
    }
    return 0;
  }

  // Scroll to specific index with snap behavior
  function scrollToIndex(index) {
    const scrollAmount = getSingleProductScrollWidth() * index;
    carousel.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });
    currentIndex = index;
  }

  // Start auto scroll
  function startAutoScroll() {
    if (autoScroll) clearInterval(autoScroll);
    
    autoScroll = setInterval(() => {
      if (isPaused) return;

      if (currentIndex >= totalItems - 1) {
        // At last item, wait for 3 seconds
        clearInterval(autoScroll);
        setTimeout(() => {
          if (!isPaused) {
            currentIndex = 0;
            scrollToIndex(currentIndex);
            startAutoScroll();
          }
        }, LAST_ITEM_WAIT);
      } else {
        currentIndex++;
        scrollToIndex(currentIndex);
      }
    }, 3500);
  }

  // Pause auto scroll
  function pauseAutoScroll() {
    isPaused = true;
    if (pauseTimeout) clearTimeout(pauseTimeout);
    
    pauseTimeout = setTimeout(() => {
      isPaused = false;
      startAutoScroll();
    }, PAUSE_DURATION);
  }

  // Handle manual navigation
  leftArrow.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      scrollToIndex(currentIndex);
      pauseAutoScroll();
    }
  });

  rightArrow.addEventListener('click', () => {
    if (currentIndex < totalItems - 1) {
      currentIndex++;
      scrollToIndex(currentIndex);
      pauseAutoScroll();
    }
  });

  // Handle touch/click interactions
  const productCards = carousel.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.addEventListener('click', () => {
      pauseAutoScroll();
    });
    
    card.addEventListener('touchstart', () => {
      pauseAutoScroll();
    });
  });

  // Handle manual scroll
  let scrollTimeout;
  carousel.addEventListener('scroll', () => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    
    // Calculate current index based on scroll position
    const scrollPosition = carousel.scrollLeft;
    const itemWidth = getSingleProductScrollWidth();
    const newIndex = Math.round(scrollPosition / itemWidth);
    
    if (newIndex !== currentIndex) {
      currentIndex = newIndex;
      pauseAutoScroll();
    }
  });

  // Initialize scroll snap behavior
  carousel.style.scrollSnapType = 'x mandatory';
  const items = carousel.querySelectorAll('.product-carousel-item');
  items.forEach(item => {
    item.style.scrollSnapAlign = 'center';
  });

  // Start auto scroll initially
  startAutoScroll();
}

// Initialize AOS if available
if (window.AOS) { 
  AOS.init({ 
    duration: 500, 
    once: true, 
    easing: 'ease-out-cubic' 
  }); 
}

document.addEventListener('shopify:section:load', function() {
  if (window.AOS) { AOS.refresh(); }
});

  } catch(e) { console.error(e); }
})();
})();
